module.exports = __webpack_public_path__ + "static/media/day-coin.8031daa0.png";